import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.toggle()
  }

  toggle() {
    const anyChecked = this.checkboxTargets.some(cb => cb.checked)
    this.checkboxTargets.forEach((cb, index) => {
      if (anyChecked) {
        cb.removeAttribute("required")
        cb.setCustomValidity("")
      } else {
        cb.setAttribute("required", "required")
        cb.setCustomValidity(index === 0 ? (window.I18n["custom_field_definitions.control_types.checkbox.select_at_least_one"] || "Please select at least one option") : "")
      }
    })
  }
}
